const renderPercentage = (dividend, divisor) => {
    const percentage = (dividend / divisor) * 100;

    return divisor !== 0 ? `${Number.isInteger(percentage) ? percentage : percentage.toFixed(2)}%` : '-';
};

export default renderPercentage;